// Reviews render with only the first N cards visible (rest carry a `hidden`
// attribute server-side, so they still exist in the DOM/schema without JS) --
// this toggles them open so a long review list doesn't dominate the PDP by default.
document.querySelectorAll('.pdp-reviews__toggle').forEach((btn) => {
  const list = btn.closest('.pdp-reviews').querySelector('.pdp-reviews__list');
  const cards = Array.from(list.querySelectorAll('.pdp-reviews__card'));
  const visibleCount = parseInt(btn.dataset.visibleCount, 10) || 8;
  const showText = btn.textContent.trim();
  const hideText = 'Show fewer reviews';

  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      cards.forEach((card, i) => { card.hidden = i >= visibleCount; });
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = showText;
      list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      cards.forEach((card) => { card.hidden = false; });
      btn.setAttribute('aria-expanded', 'true');
      btn.textContent = hideText;
    }
  });
});

// Combines the star rating + product name into the contact form's message field
// before native submit, so the moderated review request lands in one readable
// email (Shopify's contact form only reliably surfaces name/email/phone/body).
document.querySelectorAll('.arg-review-form').forEach((form) => {
  const errorEl = form.querySelector('.arg-review-form__rating-error');

  form.addEventListener('submit', (event) => {
    const checkedRating = form.querySelector('input[name="rating"]:checked');

    if (!checkedRating) {
      event.preventDefault();
      if (errorEl) errorEl.hidden = false;
      return;
    }

    if (errorEl) errorEl.hidden = true;

    const container = form.closest('.pdp-reviews');
    const productTitle = (container && container.dataset.productTitle) || '';
    const messageField = form.querySelector('.arg-review-form__message');
    const reviewText = messageField.value;

    messageField.value =
      'Product review submission\n' +
      'Product: ' + productTitle + '\n' +
      'Rating: ' + checkedRating.value + '/5\n\n' +
      reviewText;
  });
});
